<div fxLayout="column" style="padding:15px;" fxLayoutAlign="center center center">

    <mat-card ngStyle.gt-lg="width:76%;" ngStyle.lg="width:86%;" ngStyle.lt-lg="width:100%;">
        <mat-card-title>
            <app-page-header [title]="pageTitle" action=''></app-page-header>
        </mat-card-title>
        <mat-card-content fxLayout="column">

            <div fxLayout="row" fxFlex="grow" fxFlexFill="100" fxLayoutAlign="start center center">
                <mat-tab-group (selectedTabChange)="onTabChanged($event);" style="margin-top: 15px;" mat-stretch-tabs
                               fxFlex="grow">

                    <mat-tab>
                        <ng-template mat-tab-label>
                            <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                                Δηλώσεις χρηστών
                            </div>
                        </ng-template>

                        <div fxLayout="column" style="width: 100%;" *ngIf="currentTabIndex === 0">
                            <app-custom-form-reports></app-custom-form-reports>
                        </div>
                    </mat-tab>

                    <!-- Hidden: Προσωπικές δηλώσεις χρηστών tab -->

                    <mat-tab>
                        <ng-template mat-tab-label>
                            <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                                Ανακοινώσεων
                            </div>
                        </ng-template>
                        <div fxLayout="column" style="width: 100%;" *ngIf="currentTabIndex === 1">
                            <app-announcements-report></app-announcements-report>
                        </div>
                    </mat-tab>
                    <mat-tab *ngIf="localEnvironment.productSchoolId !== 1">
                        <ng-template mat-tab-label>
                            <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                                Δημόσιες / Ανώνυμες δηλώσεις
                            </div>
                        </ng-template>
                        <div fxLayout="column" style="width: 100%;" *ngIf="currentTabIndex === 2">
                            <app-public-report></app-public-report>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>

        </mat-card-content>
    </mat-card>

</div>
